import { useId } from "react";
import { ApprovalFieldProps } from "../../../../../common/ApprovalStatusField/ApprovalStatusField.types";
import { ApprovalStatusField } from "../../../../../common/ApprovalStatusField/ApprovalStatusField";
import { ApprovalFieldWrapper } from "./ApprovalField.styled";
import { InputWithLabelWrapper, TicketInfoLabel } from "../TicketInfoField/TicketInfoField.styled";
import { ticketApprovalStatusLookUp } from "src/components/Tickets/MyTickets.constants";

export const ApprovalField = ({approval}: ApprovalFieldProps) => {
    const inputId = useId();

    return (
        <InputWithLabelWrapper>
            <TicketInfoLabel htmlFor={inputId} size="medium">Approval status </TicketInfoLabel>
            <ApprovalFieldWrapper>
                <ApprovalStatusField approval={approval} />{ticketApprovalStatusLookUp[approval]?.label}
            </ApprovalFieldWrapper>
        </InputWithLabelWrapper>

    );
}